<template lang="pug"></template>

<script>
export default {
    name: 'BotaoOperacoesEmLote',
    componentOptions: {
        title: 'Operacão em Lote',
        actions: [
            [
                {
                    name: 'Lote',
                    iconClass: 'lyra-icon lyra-dashboard',
                    showView: false,
                    action: 'abrirLote',
                    route: 'operacaoLote'
                }
            ]
        ]
    },

    methods: {
        abrirLote() {
            if (this.$route.name !== 'operacaoLote') {
                this.$router.push({ name: 'operacaoLote' });
            } else {
                this.$router.go();
            }
        }
    }
};
</script>
